import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Observability for agents on \nnetwork incidents and alarms",
  subtitle: "Network operations demo",
  text: '<span style="font-weight:bold">Reduced lead time and OpEx costs </span>are \nachievable by providing agents with a \ncomprehensive view of incident details and \ninformation related to alarms and warnings.',
  label: {
    iconPath: "start.png",
    text: "Reporting - Command Center Agent Dashboard",
  },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_205"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_203"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 1_R1.mp4",
  pageNumber: "ILO_204",
};

export default DATA_NO_DEMO_ILO2;
